/**
 * Generated by orval v7.17.2 🍺
 * Do not edit manually.
 * WHIS API documentation
 * This document list all APIs available for WHIS project
 * OpenAPI spec version: 0.1.5
 */

export type ReportsFindCoordinatesAnimalType =
  (typeof ReportsFindCoordinatesAnimalType)[keyof typeof ReportsFindCoordinatesAnimalType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ReportsFindCoordinatesAnimalType = {
  vertebrate: 'vertebrate',
  invertebrate: 'invertebrate',
} as const;
